import SectionLabel from "./SectionLabel";
import GradientHeading from "./GradientHeading";

export default function SectionHeader({ label, heading, children }) {
  return (
    <div className="xl:grid xl:grid-cols-4 xl:gap-5">
      <SectionLabel>{label}</SectionLabel>
      <div className="mt-3 xl:col-span-3 xl:mt-0">
        <GradientHeading>{heading}</GradientHeading>
        {children}
      </div>
    </div>
  );
}
